"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _isValid2 = _interopRequireDefault(require("date-fns/isValid"));
var _isEqual = _interopRequireDefault(require("date-fns/isEqual"));
var _nextFriday = _interopRequireDefault(require("date-fns/nextFriday"));
var _getHours = _interopRequireDefault(require("date-fns/getHours"));
var _set = _interopRequireDefault(require("date-fns/set"));
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _addHours = _interopRequireDefault(require("date-fns/addHours"));
var _ru = _interopRequireDefault(require("date-fns/locale/ru"));
var _date = require("../../utils/date");
var _datepicker = _interopRequireDefault(require("../../styles/components/datepicker"));
var _Button = _interopRequireDefault(require("../Button"));
var _Input = _interopRequireDefault(require("../Input"));
var _excluded = ["allowSameDay", "forceShown", "filterDate", "multiple", "minDate", "maxDate"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DatePicker = /*#__PURE__*/function (_React$PureComponent) {
  function DatePicker(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, DatePicker);
    _this = _callSuper(this, DatePicker, [props]);
    var initialValue = props.value,
      forceShown = props.forceShown,
      externalShortcuts = props.shortcuts;
    _this.state = {
      isOpen: forceShown,
      isFillingStart: forceShown,
      value: initialValue,
      initialValue: initialValue,
      shortcuts: externalShortcuts || DatePicker.getShortcuts()
    };
    _this.formatDate = _this.formatDate.bind(_this);
    _this.handleChangeEnd = _this.handleChangeEnd.bind(_this);
    _this.handleChangeShortcut = _this.handleChangeShortcut.bind(_this);
    _this.handleChangeStart = _this.handleChangeStart.bind(_this);
    _this.handleReset = _this.handleReset.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleTimeChange = _this.handleTimeChange.bind(_this);
    _this.inputRenderer = _this.inputRenderer.bind(_this);
    _this.rendererContainer = _this.rendererContainer.bind(_this);
    _this.shortcutsRenderer = _this.shortcutsRenderer.bind(_this);
    _this.timePickerRenderer = _this.timePickerRenderer.bind(_this);
    _this.toggleDatePicker = _this.toggleDatePicker.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(DatePicker, _React$PureComponent);
  return (0, _createClass2["default"])(DatePicker, [{
    key: "handleChangeStart",
    value: function handleChangeStart(startDate) {
      var _this$props = this.props,
        showTimeSelect = _this$props.showTimeSelect,
        multiple = _this$props.multiple;
      var value = multiple ? [startDate, startDate] : startDate;
      var preventEvent = multiple || showTimeSelect;
      this.setState({
        value: value,
        isOpen: preventEvent,
        isFillingStart: showTimeSelect
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var onChange = this.props.onChange;
      var value = this.state.value;
      onChange(value);
      this.toggleDatePicker();
    }
  }, {
    key: "handleChangeEnd",
    value: function handleChangeEnd(endDate) {
      var oldValue = this.state.value;
      var onChange = this.props.onChange;
      var value = [oldValue[0], endDate];
      this.setState({
        value: value,
        isOpen: false
      }, onChange(value));
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      var onChange = this.props.onChange;
      this.setState({
        value: null
      }, onChange(null));
      this.toggleDatePicker();
    }
  }, {
    key: "handleTimeChange",
    value: function handleTimeChange(ev) {
      ev.stopPropagation();
      var stateDate = this.state.value;
      var value = ev.currentTarget.value;
      var _value$split = value.split(':'),
        _value$split2 = (0, _slicedToArray2["default"])(_value$split, 2),
        hours = _value$split2[0],
        minutes = _value$split2[1];
      var selectedDate = stateDate || new Date();
      var newDate = (0, _set["default"])(selectedDate, {
        hours: hours,
        minutes: minutes
      });
      this.setState({
        value: newDate
      });
    }
  }, {
    key: "handleChangeShortcut",
    value: function handleChangeShortcut(value) {
      this.setState({
        value: value
      });
    }
  }, {
    key: "inputRenderer",
    value: function inputRenderer() {
      var value = this.state.value;
      var _this$props2 = this.props,
        multiple = _this$props2.multiple,
        customPlaceholder = _this$props2.placeholder;
      var placeholder = customPlaceholder || (multiple ? 'Все даты' : 'Выбрать дату');
      var label;
      if (value) {
        if (multiple) {
          var _value = (0, _slicedToArray2["default"])(value, 2),
            startDate = _value[0],
            endDate = _value[1];
          label = DatePicker.isEqualDates(startDate, endDate) ? this.formatDate(startDate) : "".concat(this.formatDate(startDate), " \u2013 ").concat(this.formatDate(endDate));
        } else {
          label = this.formatDate(value);
        }
      }
      return /*#__PURE__*/_react["default"].createElement(StyledButton, {
        onClick: this.toggleDatePicker
      }, label || placeholder);
    }
  }, {
    key: "resetRenderer",
    value: function resetRenderer() {
      var value = this.state.value;
      return /*#__PURE__*/_react["default"].createElement(StyledResetButton, {
        checked: !value,
        onClick: this.handleReset
      }, "\u0412\u0441\u0435 \u0434\u0430\u0442\u044B");
    }
  }, {
    key: "toggleDatePicker",
    value: function toggleDatePicker() {
      var onChange = this.props.onChange;
      var value = this.state.value;
      this.setState(function (prevState) {
        if (prevState.isOpen) onChange(value);
        return {
          isFillingStart: true,
          isOpen: !prevState.isOpen
        };
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      var dateFormat = this.props.dateFormat;
      return (0, _date.formatDate)(date, dateFormat);
    }
  }, {
    key: "shortcutsRenderer",
    value: function shortcutsRenderer() {
      var _this2 = this;
      var shortcuts = this.state.shortcuts;
      return /*#__PURE__*/_react["default"].createElement(StyledShortcuts, null, shortcuts.map(function (_ref) {
        var label = _ref.label,
          value = _ref.value;
        return /*#__PURE__*/_react["default"].createElement(StyledShortcut, {
          key: label,
          functional: true,
          "data-value": value,
          onClick: function onClick() {
            return _this2.handleChangeShortcut(value);
          }
        }, label);
      }));
    }
  }, {
    key: "timePickerRenderer",
    value: function timePickerRenderer() {
      var value = this.state.value;
      var date = (0, _date.formatDate)(value, 'HH:mm');
      return /*#__PURE__*/_react["default"].createElement(StyledTime, {
        value: date,
        onChange: this.handleTimeChange,
        type: "time"
      });
    }
  }, {
    key: "rendererContainer",
    value: function rendererContainer(_ref2) {
      var className = _ref2.className,
        children = _ref2.children;
      var _this$props3 = this.props,
        multiple = _this$props3.multiple,
        required = _this$props3.required,
        showShortcuts = _this$props3.showShortcuts,
        showTimeSelect = _this$props3.showTimeSelect,
        submitLabel = _this$props3.submitLabel,
        suffix = _this$props3.suffix;
      var value = this.state.value;
      var allowEmpty = !required && multiple;
      var buttonLabel = submitLabel && (0, _date.formatDate)(value, "".concat(submitLabel, " d MMMM, HH:mm"));
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(StyledHead, null, allowEmpty && this.resetRenderer(), showShortcuts && this.shortcutsRenderer(), showTimeSelect && this.timePickerRenderer()), /*#__PURE__*/_react["default"].createElement(StyledChildren, null, children), suffix, buttonLabel && value && /*#__PURE__*/_react["default"].createElement(StyledBottom, null, /*#__PURE__*/_react["default"].createElement(StyledSubmit, {
        onClick: this.handleSubmit
      }, buttonLabel)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        value = _this$state.value,
        isOpen = _this$state.isOpen,
        isFillingStart = _this$state.isFillingStart;
      var _this$props4 = this.props,
        allowSameDay = _this$props4.allowSameDay,
        forceShown = _this$props4.forceShown,
        filterDate = _this$props4.filterDate,
        multiple = _this$props4.multiple,
        minDate = _this$props4.minDate,
        maxDate = _this$props4.maxDate,
        props = (0, _objectWithoutProperties2["default"])(_this$props4, _excluded);
      var startDate = value;
      var endDate = null;
      if (multiple && value) {
        var _value2 = (0, _slicedToArray2["default"])(value, 2);
        startDate = _value2[0];
        endDate = _value2[1];
      }
      return /*#__PURE__*/_react["default"].createElement(StyledDatePicker, props, /*#__PURE__*/_react["default"].createElement(_datepicker["default"], null), this.inputRenderer(), /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
        allowSameDay: allowSameDay,
        calendarContainer: this.rendererContainer,
        endDate: endDate,
        filterDate: filterDate,
        inline: forceShown || isOpen && isFillingStart,
        isClearable: true,
        locale: _ru["default"],
        minDate: minDate,
        maxDate: maxDate,
        onChange: this.handleChangeStart,
        onClickOutside: this.toggleDatePicker,
        selected: startDate,
        selectsStart: !multiple,
        startDate: startDate,
        openToDate: startDate
      }), multiple && /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
        allowSameDay: allowSameDay,
        calendarContainer: this.rendererContainer,
        endDate: endDate,
        filterDate: filterDate,
        inline: isOpen && !isFillingStart,
        locale: _ru["default"],
        minDate: minDate,
        maxDate: maxDate,
        onChange: this.handleChangeEnd,
        onClickOutside: this.toggleDatePicker,
        selected: startDate,
        selectsEnd: true,
        startDate: startDate
      }));
    }
  }], [{
    key: "getShortcuts",
    value: function getShortcuts() {
      var today = new Date();
      var tomorrow = (0, _addDays["default"])(today, 1);
      return [{
        label: 'Через час',
        value: (0, _addHours["default"])(today, 1)
      }, {
        label: 'Через 2 часа',
        value: (0, _addHours["default"])(today, 2)
      }, {
        label: 'Вечером',
        value: (0, _getHours["default"])(today) > 18 ? (0, _set["default"])(tomorrow, {
          hours: 18
        }) : (0, _set["default"])(today, {
          hours: 18,
          minutes: 0
        })
      }, {
        label: 'Завтра',
        value: tomorrow
      }, {
        label: 'Послезавтра',
        value: (0, _addDays["default"])(today, 2)
      }, {
        label: 'На выходных',
        value: (0, _nextFriday["default"])(today)
      }];
    }
  }, {
    key: "isValid",
    value: function (_isValid) {
      function isValid(_x) {
        return _isValid.apply(this, arguments);
      }
      isValid.toString = function () {
        return _isValid.toString();
      };
      return isValid;
    }(function (date) {
      return (0, _isValid2["default"])(date);
    })
  }, {
    key: "isEqualDates",
    value: function isEqualDates(date1, date2) {
      return (0, _isEqual["default"])(date1, date2);
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, _ref4) {
      var value = _ref3.value,
        multiple = _ref3.multiple;
      var oldValue = _ref4.value,
        initialValue = _ref4.initialValue;
      if (value && value !== initialValue) {
        return multiple ? {
          value: initialValue ? [initialValue[0] !== value[0] ? value[0] : oldValue[0], initialValue[1] !== value[1] ? value[1] : oldValue[0]] : value,
          initialValue: value
        } : {
          value: value,
          initialValue: initialValue
        };
      }
      return null;
    }
  }]);
}(_react["default"].PureComponent);
DatePicker.propTypes = {
  filterDate: _propTypes["default"].func,
  allowSameDay: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired), _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date))]),
  dateFormat: _propTypes["default"].string,
  minDate: _propTypes["default"].number,
  maxDate: _propTypes["default"].number,
  forceShown: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  showShortcuts: _propTypes["default"].bool,
  showTimeSelect: _propTypes["default"].bool,
  submitLabel: _propTypes["default"].string,
  suffix: _propTypes["default"].node
};
DatePicker.defaultProps = {
  allowSameDay: true,
  className: '',
  dateFormat: 'd MMM yy',
  filterDate: null,
  forceShown: false,
  multiple: false,
  minDate: null,
  maxDate: null,
  onChange: Function.prototype,
  placeholder: null,
  required: true,
  showShortcuts: false,
  showTimeSelect: false,
  submitLabel: null,
  value: null,
  suffix: null
};
var StyledDatePicker = _styledComponents["default"].div.withConfig({
  displayName: "DatePicker__StyledDatePicker",
  componentId: "sc-128it3b-0"
})(["position:relative;.react-datepicker{left:0;border:none;display:flex;flex-direction:column;border-radius:0;position:absolute;top:calc(100% + 5px);box-shadow:0 2px 8px rgba(0,0,0,0.3);z-index:2;}.react-datepicker__month-container{padding:5px 10px 10px;}.react-datepicker__input-container{display:none;}.react-datepicker__header{padding:0;border:none;background:none;line-height:48px;&:first-letter{text-transform:uppercase;}}.react-datepicker__current-month,.react-datepicker-time__header,.react-datepicker-year-header{color:#999;font-size:19px;font-weight:normal;border-bottom:3px solid #f8f8f8;}.react-datepicker__day--selected,.react-datepicker__day--in-selecting-range,.react-datepicker__day--in-range,.react-datepicker__month-text--selected,.react-datepicker__month-text--in-selecting-range,.react-datepicker__month-text--in-range{background-color:#ffedce;color:#000;}.react-datepicker__day-names{font-weight:500;text-transform:uppercase;}.react-datepicker__day-names,.react-datepicker__week{font-size:15px;}.react-datepicker__day-name,.react-datepicker__day{margin:0;width:35px;height:35px;font-size:15px;border-radius:0;line-height:35px;text-align:center;&--weekend{color:#bd6262;}&--selected{color:#fff;background-color:#595959;}&--disabled,&--outside-month{opacity:0.3;background:none;pointer-events:none;}}.react-datepicker__month{margin:0;}.react-datepicker__navigation{top:18px;width:15px;height:15px;border-width:0.5rem;&--previous{left:13px;}&--next{right:13px;}}.react-datepicker__triangle{display:none;}"]);
var StyledShortcuts = _styledComponents["default"].div.withConfig({
  displayName: "DatePicker__StyledShortcuts",
  componentId: "sc-128it3b-1"
})(["display:flex;flex-flow:wrap;margin-bottom:10px;"]);
var StyledShortcut = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "DatePicker__StyledShortcut",
  componentId: "sc-128it3b-2"
})(["width:50%;text-align:left;font-size:12px;line-height:22px;outline:none;&:hover{color:#007aff;}"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "DatePicker__StyledContainer",
  componentId: "sc-128it3b-3"
})(["position:relative;"]);
var StyledChildren = _styledComponents["default"].div.withConfig({
  displayName: "DatePicker__StyledChildren",
  componentId: "sc-128it3b-4"
})(["position:relative;"]);
var StyledHead = _styledComponents["default"].div.withConfig({
  displayName: "DatePicker__StyledHead",
  componentId: "sc-128it3b-5"
})(["padding:10px 10px 0;"]);
var StyledBottom = _styledComponents["default"].div.withConfig({
  displayName: "DatePicker__StyledBottom",
  componentId: "sc-128it3b-6"
})(["padding:0 10px 10px;"]);
var StyledSubmit = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "DatePicker__StyledSubmit",
  componentId: "sc-128it3b-7"
})(["background:#007aff;height:36px;color:#fff;padding:0;text-align:center;width:100%;&:hover{color:white;}"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "DatePicker__StyledButton",
  componentId: "sc-128it3b-8"
})(["height:36px;width:100%;border:none;color:black;font-size:14px;text-align:left;&:hover{color:black;}"]);
var StyledResetButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "DatePicker__StyledResetButton",
  componentId: "sc-128it3b-9"
})(["width:86px;height:36px;font-size:14px;border-radius:18px;border:solid 1px #007aff;", ""], function (p) {
  return p.checked && "\n    color: white;\n    border-color: inherit;\n    background-color: #007aff;\n\n    &:hover {\n      color: white;\n      border-color: inherit;\n    }\n  ";
});
var StyledTime = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "DatePicker__StyledTime",
  componentId: "sc-128it3b-10"
})(["width:100%;padding:0;border:none;font-size:28px;outline:none;::-webkit-datetime-edit-fields-wrapper{display:flex;}::-webkit-datetime-edit-text{padding:4px 0;width:32px;text-align:center;}::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field{background:white;border:1px solid #e6e9ee;border-radius:4px;padding:5px 0;flex:1;text-align:center;}::-webkit-datetime-edit-hour-field:focus,::-webkit-datetime-edit-minute-field:focus{color:black;background:white;border-color:#007aff;}::-webkit-datetime-edit-ampm-field,::-webkit-clear-button,::-webkit-calendar-picker-indicator,::-webkit-calendar-picker-indicator:focus,::-webkit-inner-spin-button{display:none;-webkit-appearance:none;}"]);
DatePicker.StyledButton = StyledButton;
var _default = exports["default"] = DatePicker;